import { Box, Grid2, Tooltip, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { Fragment } from 'react/jsx-runtime';
import { ReactComponent as AddIcon } from '../../../../assets/icons/add-icon.svg';
import { ReactComponent as DownloadIcon } from '../../../../assets/icons/download-icon.svg';
import { AttachmentStatus } from '../../../../models/models';
import { uploadAttachmentStart } from '../../../../store/attachment/attachment.action';
import { openDialog } from '../../../../store/dialog/dialog.action';
import { DIALOG_TYPES } from '../../../../store/dialog/dialog.types';
import { getNodeStart } from '../../../../store/node/node.action';
import { selectNodeSelected } from '../../../../store/node/node.selector';
import {
    getDocumentStatusDate,
    getDocumentStatusUser,
    getStatusLabel,
} from '../../../../utils/data/data.utils';
import { canAddAttachment, isViewer } from '../../../../utils/role/role.utils';
import { AttachmentStatusIcon } from '../../../attachment-status-icon/attachment-status-icon.component';
import DocumentStatusIcon from '../../../attachment-status-icon/document-status-icon.component';
import {
    CustomAccordionDetailsGridText,
    CustomAccordionDetailsTitleText,
} from '../node-accordion-details.styles';

const NodeAccordionDetailsDocumentsGrid = () => {
    const nodeSelected = useSelector(selectNodeSelected);

    const dispatch = useDispatch();

    const handleOpenAttachmentActions = (
        id: number,
        status: AttachmentStatus,
        refusal_notes: string,
        created_by: string,
        approved_by: string,
        rejected_by: string,
        replaced_by: string
    ) => {
        dispatch(
            openDialog(
                DIALOG_TYPES.SELECT_ATTACHMENT_ACTION,
                {
                    id: id,
                    type: 'document',
                    status: status,
                    refusal_notes: refusal_notes,
                    created_by: created_by,
                    approved_by: approved_by,
                    rejected_by: rejected_by,
                    replaced_by: replaced_by,
                },
                'xs'
            )
        );
    };

    const handleFileChange = (event: any) => {
        const files = event.target.files;
        if (files.length > 0) {
            const file = files[0];
            dispatch(
                uploadAttachmentStart(
                    file,
                    'document',
                    nodeSelected!.id,
                    () => {
                        dispatch(getNodeStart(nodeSelected!.id));
                    }
                )
            );
            event.target.value = '';
        }
    };

    return (
        <Fragment>
            <CustomAccordionDetailsTitleText>
                {`DOCUMENTI`}
                {canAddAttachment(nodeSelected!) && (
                    <Typography component={'label'} height={40}>
                        <AddIcon style={{ cursor: 'pointer' }} />
                        <input type="file" hidden onChange={handleFileChange} />
                    </Typography>
                )}
            </CustomAccordionDetailsTitleText>
            <Box my={2} />
            {nodeSelected!.documents.map((d) => {
                return (
                    <Grid2
                        container
                        height={40}
                        key={d.id}
                        alignItems={'center'}
                        onClick={() =>
                            !isViewer(nodeSelected!) &&
                            nodeSelected!.status.key === 'active' &&
                            handleOpenAttachmentActions(
                                d.id,
                                d.status.key,
                                d.refusal_notes,
                                d.created_by,
                                d.approved_by,
                                d.rejected_by,
                                d.replaced_by
                            )
                        }
                        sx={{
                            '&:hover': {
                                cursor:
                                    isViewer(nodeSelected!) ||
                                    nodeSelected!.status.key === 'in_review'
                                        ? 'default'
                                        : 'pointer',
                                backgroundColor: (theme) =>
                                    isViewer(nodeSelected!) ||
                                    nodeSelected!.status.key === 'in_review'
                                        ? 'transparent'
                                        : theme.palette.action.hover,
                            },
                        }}
                    >
                        <Grid2 container size={4} gap={1}>
                            <Grid2
                                size={1}
                                container
                                justifyContent={'end'}
                                alignItems={'center'}
                            >
                                <DocumentStatusIcon document={d} />
                            </Grid2>
                            <Grid2 size={7} container alignItems={'center'}>
                                <Tooltip title={d.name}>
                                    <CustomAccordionDetailsGridText>
                                        {d.name}
                                    </CustomAccordionDetailsGridText>
                                </Tooltip>
                            </Grid2>
                            <Grid2 container alignItems={'center'}>
                                <Tooltip
                                    title="Scarica"
                                    onClick={(event) => event.stopPropagation()}
                                >
                                    <a
                                        href={d.path}
                                        download
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <DownloadIcon />
                                    </a>
                                </Tooltip>
                            </Grid2>
                        </Grid2>
                        <Grid2 size={3} container>
                            <Grid2 size={12} alignContent={'center'}>
                                <CustomAccordionDetailsGridText>
                                    {getDocumentStatusDate(d)}
                                </CustomAccordionDetailsGridText>
                            </Grid2>
                        </Grid2>
                        <Grid2 size={3} container alignItems={'center'}>
                            <CustomAccordionDetailsGridText>
                                {getDocumentStatusUser(d)}
                            </CustomAccordionDetailsGridText>
                        </Grid2>
                        <Grid2 size={2} container alignItems={'center'}>
                            <AttachmentStatusIcon document={d} />
                            <Box mx={0.5} />
                            {(() => {
                                const color = getStatusLabel(d);
                                return (
                                    <CustomAccordionDetailsGridText
                                        color={color}
                                    >
                                        {d.status.key !== 'active'
                                            ? d.status.label[0].toUpperCase() +
                                              d.status.label.slice(1)
                                            : ''}
                                    </CustomAccordionDetailsGridText>
                                );
                            })()}
                        </Grid2>
                    </Grid2>
                );
            })}
        </Fragment>
    );
};

export default NodeAccordionDetailsDocumentsGrid;
